document.addEventListener("click", function (e) {
  // Checkout drawer
  const checkoutButton = e.target.closest(
    '.upcart-checkout-button-container a[href="/checkout"]'
  );
  if (checkoutButton) {
    console.log("checkout_started", {
      buttonType: "upcart",
      url: window.location.href,
    });

    posthog.capture("checkout_started", {
      buttonType: "upcart",
      url: window.location.href,
    });
  }

  // Quick add to cart
  if (e.target.closest(".js-quick-add-btn .bdoh-button")) {
    const productEl = e.target.closest("[data-product]");

    const options = {
      product_id: productEl.dataset.productId,
      sku: productEl.dataset.sku,
      category: productEl.dataset.collection,
      name: productEl.dataset.productName,
      variant: productEl.dataset.variantId,
      price: Number(productEl.dataset.price),
      quantity: 1,
      position: Number(productEl.dataset.position),
      url: window.location.href,
      image_url: productEl.dataset.image,
      add_type: "quick",
    };

    console.log("product_added_to_cart_quick", options);

    posthog.capture("product_added_to_cart_quick", options);
  }

  const relatedProduct = e.target.closest(
    ".ysw-more-products__grid [data-product]"
  );
  if (relatedProduct) {
    posthog.capture("related_product_clicked", {
      product_id: relatedProduct.dataset.productId,
      name: relatedProduct.dataset.productName,
      position: Number(relatedProduct.dataset.position),
      url: window.location.href,
      source: "related_products",
    });
  }

  const pdpBanner = e.target.closest("#section-pdp .gtm-pdp-banner-click");
  if (pdpBanner) {
    const options = {
      product_id: pdpBanner.dataset.productId,
      product_handle: pdpBanner.dataset.productHandle,
      collection_id: pdpBanner.dataset.collectionId,
      collection_handle: pdpBanner.dataset.collectionHandle,
      url: window.location.href,
      source: "pdp_collection_banner",
    };
    posthog.capture("pdp_collection_banner_click", options);
  }

  const searchButton = e.target.closest(".js-bwd-search-header");
  if (searchButton) {
    const isClosing = searchButton.classList.contains("active");
    posthog.capture(!isClosing ? "close_search" : "open_search", {
      url: window.location.href,
    });
  }

  const searchResult = e.target.closest(".results a");
  if (searchResult) {
    posthog.capture("search_result_product_click", {
      url: window.location.href,
      result_url: searchResult.href,
    });
  }

  const searchTag = e.target.closest("[data-query]");
  if (searchTag) {
    posthog.capture("search_result_tag_click", {
      url: window.location.href,
      search_term: searchTag.dataset.query,
    });
  }
});

const searchInput = document.querySelector("#search-input");
if (searchInput) {
  searchInput.addEventListener("input", function (e) {
    // Debounce to avoid too many events
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      if (e.target.value) {
        posthog.capture("search_query", {
          query: e.target.value,
          url: window.location.href,
        });
      }
    }, 1000); // Wait 1s after typing stops
  });
}
